import BaseFactory from 'services/sports/default/base-factory';
import Const from 'constants';
import SimplexClassic from './simplex-classic';

const classesMap = {
    [Const.GAME_TYPE_CLASSIC]: SimplexClassic,
};

class Factory extends BaseFactory {
    createObj(objectName, params) {
        const {sportConfig} = params;
        const gameType = sportConfig.getGameType();

        if (gameType in classesMap) {
            return new classesMap[gameType](params);
        }

        return new SimplexClassic(params);
    }
}

export {Factory};
